import { render, staticRenderFns } from "./img_body.vue?vue&type=template&id=d83e372e&scoped=true&"
import script from "./img_body.vue?vue&type=script&lang=js&"
export * from "./img_body.vue?vue&type=script&lang=js&"
import style0 from "./img_body.vue?vue&type=style&index=0&id=d83e372e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83e372e",
  null
  
)

export default component.exports